import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { NumericDictionary } from 'lodash';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { StatiEvento } from 'src/app/model/StatiEvento.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { EventiService } from 'src/app/services/eventi.service';
import { TemplateDataSource } from 'src/app/services/template.datasource';
import { TemplateService } from 'src/app/services/template.service';
import { Toolbar, ToolbarEvent } from 'src/app/shared/components/toolbar/toolbar';

export interface Template {
  codiceTemplate: string,
  tipoSegnalazione: string,
  descrizione: string,
  distribuibile: string
}

@Component({
  selector: 'app-elenco-template',
  templateUrl: './elenco-template.component.html',
  styleUrls: ['./elenco-template.component.css']
})
export class ElencoTemplateComponent implements OnInit {

  risultatiPerPagina: number = 10;
  displayedColumns: string[] = ['idTemplate', 'tpModulo', 'descrizione', 'flDistribuito', 'actions'];
  dataSource: TemplateDataSource;
  statoEvento: string = '';
  acl = sessionStorage.getItem("acl");
  statiEventoEnum: typeof StatiEvento = StatiEvento;

  public searchFilters: ModelEventiCalamitosi.TemplateSearchableDto;

  templatesSearchableDto: ModelEventiCalamitosi.TemplateSearchableDto = {
    idEvento: null,
    tpModulo: null,
    idTemplate: null,
    flDistribuito: null,
    descrizione: null
  };

  public openToggle: number = 0;
  public form: FormGroup;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Output()
  public onToolbarEvent: EventEmitter<ToolbarEvent> = new EventEmitter();

  public toolbar: Toolbar;
  isDgpe: boolean = false;

  private buildForm(): void {
    let group = {
      idTemplate: new FormControl(null, null),
      descrizione: new FormControl(null, null),
      tpModulo: new FormControl(null, null),
      flDistribuito: new FormControl(null, null)
    }
    this.form = new FormGroup(group);
  }

  denominazione: string;

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private templateService: TemplateService,
    private lsEventiDialogSvc: DialogService,
    private alertsCenterService: AlertsCenterService,
    private eventiService: EventiService) {
    this.eventiService.getEvento(+this.idEvento).subscribe(res => {
      this.statoEvento = res.stato
      this.denominazione = res.denominazione;
    })
    // this.generateToolBar();
    this.isDgpe = this.acl == AclTipo.DGPE? true:false;
  }

  arrowFlag: boolean = false;
  isModifica: boolean = true;
  idEvento: string = this.router.snapshot.params.id;

  ngOnInit(): void {
    this.modeSelector();
    this.generateToolBar();
    this.buildForm();
    this.dataSource = new TemplateDataSource(this.templateService);
    this.templatesSearchableDto.idEvento = Number(this.idEvento);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
  }

  modeSelector() {
    if (this.route.url.startsWith('/dettaglio-evento')) this.isModifica = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // if(this.acl === AclTipo.DGPE) {
      //   this.templatesSearchableDto.tpModulo = 1;
      //   this.templatesSearchableDto.flDistribuito = "S";
      // }
      this.dataSource.loadTemplates('', this.templatesSearchableDto, 'idTemplate,ASC', 0, this.risultatiPerPagina);

      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      // reset the paginator after sorting
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaTemplate();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }

  public ricercaListaTemplate(resetPage?: boolean): void {

    this.searchFilters = {
      idEvento: this.templatesSearchableDto.idEvento,
      idTemplate: this.form.controls['idTemplate'].value !== "" ? this.form.controls['idTemplate'].value : null,
      tpModulo: this.form.controls['tpModulo'].value !== "" ? this.form.controls['tpModulo'].value : null,
      flDistribuito: this.form.controls['flDistribuito'].value !== "" ? this.form.controls['flDistribuito'].value : null,
      descrizione: this.form.controls['descrizione'].value !== "" ? this.form.controls['descrizione'].value : null,
    }
    this.dataSource.loadTemplates('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
  }

  showTemplateOption(path: string) {
    if (path === 'nuovo') this.route.navigate([this.route.url + '/nuovo-template'], { state: { denominazione: this.denominazione } });
    else this.route.navigate([this.route.url + '/importa-template']);
  }

  private generateToolBar() {
    if (this.isModifica) {
      this.toolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Modifica',
            btnIconClass: 'create',
            btnActionEvent: 'edit',
            btnCssClass: 'btn btn-secondary'
          },
          {
            btnTitle: 'Elimina template',
            btnIconClass: 'delete',
            btnActionEvent: 'remove',
            btnCssClass: 'btn btn-primary'
          }
        ]
      }
    }
    else if (
      ((this.statoEvento === StatiEvento.RACCOLTA_DATI_PE || this.statoEvento === StatiEvento.POST_EMERGENZA) && (this.acl === 'dpcpl' || this.acl === 'edel'))
      || this.statoEvento === StatiEvento.EMERGENZA_NON_RICONOSCIUTA) {
      this.toolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      }
    }
    else {
      this.toolbar = {
        toolbarCss: 'toolbar-vertical',
        actions: [
          {
            btnTitle: 'Dettaglio',
            btnIconClass: 'article',
            btnActionEvent: 'detail',
            btnCssClass: 'btn btn-secondary'
          }
        ]
      }
    }
  }

  distribuitedtemplateCaseToolbar(stato: number): Toolbar {
    let toolbar: Toolbar = { toolbarCss: 'toolbar-vertical', actions: [] }

    if (((this.statoEvento === StatiEvento.RACCOLTA_DATI_PE || this.statoEvento === StatiEvento.POST_EMERGENZA || this.statoEvento === StatiEvento.ATTESA_EMERGENZA) && (this.acl === 'dpcpl' || this.acl === 'edel'))
    || this.statoEvento === StatiEvento.EMERGENZA_NON_RICONOSCIUTA) {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        }
      )
      return toolbar
    } else {
      toolbar.actions.push(
        {
          btnTitle: 'Dettaglio',
          btnIconClass: 'article',
          btnActionEvent: 'detail',
          btnCssClass: 'btn btn-secondary'
        },
        {
          btnTitle: 'Modifica',
          btnIconClass: 'create',
          btnActionEvent: 'edit',
          btnCssClass: 'btn btn-secondary'
        },
      )
    }
    //Se sono dgpe e l'evento è stato: in attesa di emergenza devo
    //rimuovere la modalità modifica dato che il dgpe per ora può
    //modificare template dopo aver associato il dpgr all'ocdpc
    if (this.statoEvento === StatiEvento.ATTESA_EMERGENZA && this.acl === 'dgpe') {
      toolbar.actions.pop()
    }

    //Solo i template di tipo pubblico possono
    //essere visualizzati in modalità di modifica
    // Se sono in post-emergenza quindi rimuovo la modalità di modifica
    if (stato > 1 && (this.statoEvento === StatiEvento.RACCOLTA_DATI_PE
      || this.statoEvento === StatiEvento.POST_EMERGENZA) && this.acl === 'dgpe') {
      toolbar.actions.pop()
    }
    return toolbar
  }

  public handleToolbarEvent(event: ToolbarEvent): void {
    if (event.event === 'edit') {
      this.route.navigate([this.route.url + "/" + "modifica-template/" + event.data.idTemplate], { state: { denominazione: this.denominazione } });
    }
    else if (event.event === 'detail') {
      this.route.navigate([this.route.url + "/" + "dettaglio-template/" + event.data.idTemplate], { state: { denominazione: this.denominazione } });
    }
    else if (event.event === 'remove') {
      this.openDeleteConfirmDialog(event.data.idTemplate);
    }
  }

  onNavigate() {
    if (this.route.url.startsWith('/modifica-evento') && (this.acl === 'dpcpl' || this.acl === 'edel')) this.route.navigate(["modifica-evento/" + this.router.snapshot.params.id]);
    else this.route.navigate(["dettaglio-evento/" + this.router.snapshot.params.id]);
  }

  openDeleteConfirmDialog(idTemplate: number) {
    let title = 'Cancellazione template';
    let message = 'Vuoi davvero eliminare questo template?'
    this.lsEventiDialogSvc.openDialog(title, message).subscribe(
      result => {
        let confirmed = `${result}`;
        if (confirmed == "true") {
          this.cancellaTemplate(idTemplate);
        }
      }
    );
  }

  public cancellaTemplate(idTemplate: number): void {

    this.templateService.deleteTemplate(idTemplate).subscribe(results => {
      this.alertsCenterService.showAlert({
        message: `Cancellazione effettuata con successo`,
        type: 'success',
        autoClosable: false
      });
      this.ricercaListaTemplate();
    }, err => {
      this.alertsCenterService.showAlert({
        message: err.error.esitoServizio.descrizioneEsito,
        type: 'danger',
        autoClosable: false,
        closeInMillis: 6000
      });
    })
  }

  onReset() {
    this.templatesSearchableDto = {
      idEvento: null,
      tpModulo: null,
      idTemplate: null,
      flDistribuito: null,
      descrizione: null
    };
    this.templatesSearchableDto.idEvento = Number(this.idEvento);
    this.form.reset();
    this.dataSource.loadTemplates('', this.templatesSearchableDto, 'idTemplate,ASC', 0, this.risultatiPerPagina);
  }

  //rimane in ascolto: se il click non è fatto sull'icona chiude il menù
  @HostListener('document:click', ['$event'])
  documentClick(event) {
    if (event.srcElement.innerText !== 'more_horiz') this.openToggle = 0;
  }
}
